export const MOUSE_ENTER_NAV = 'concrete/MOUSE_ENTER_NAV'
export const NAV_OVER_ARTISTS = 'concrete/NAV_OVER_ARTISTS'
export const NAV_OUT_ARTISTS = 'concrete/NAV_OUT_ARTISTS'



// WEBPACK FOOTER //
// ./src/components/navigation/action-types.js